import { app } from '../base';

const fetch = async () => {
    let result = '';

    // const storage = app.storage();
    // const listRef = storage.ref().child('images');


    // const folders = await listRef.listAll();

    // for (const folder of folders.prefixes) {
    //     const files = await folder.listAll();

    //     for (const file of files.items) {
    //         result += file.fullPath;
    //         result += '\n';
    //     }
    // }

    return result;



    // 3. Find all the prefixes and items using listAll()
    // listRef.listAll()
    //     .then((res) => {
    //         // Process prefixes (folders)
    //         res.prefixes.forEach((folderRef) => {
    //             console.log('Folder:', folderRef.fullPath);
    //             // In v8, you get the URL like this:
    //             // folderRef.getDownloadURL().then(url => console.log(url));
    //         });

    //         // Process items (files)
    //         res.items.forEach((itemRef) => {
    //             console.log('File:', itemRef.fullPath);

    //             // Get the download URL for the file
    //             // itemRef.getDownloadURL().then((url) => {
    //             //     console.log('Download URL:', url);
    //             // });
    //         });
    //     })
    //     .catch((error) => {
    //         // Handle any errors
    //         console.error("Error listing files:", error);
    //     });
};

export default { fetch };